// The v9 handoff provides English and Japanese forms. Other report languages
// use the English form until a dedicated form is supplied.
const SURVEY_URLS = Object.freeze({
  en: "https://docs.google.com/forms/d/e/1FAIpQLSf6gQMppBKRe5oHyk290nwCEPQyTGWqbPQDjjR0cmlj0G5Wsw/viewform?usp=publish-editor",
  ja: "https://docs.google.com/forms/d/e/1FAIpQLScaFecosNddGbI6LtlxhGaMge-Jbp9l9dWUWslEo9Ng35CvHQ/viewform?usp=dialog",
});

export const getGazeSurveyUrl = (locale) =>
  SURVEY_URLS[locale] || SURVEY_URLS.en;

// Accept only the supplied forms, without arbitrary destinations or prefill.
export const isAllowedGazeSurveyUrl = (url) =>
  typeof url === "string" && Object.values(SURVEY_URLS).includes(url);
